import React from 'react';
import { Button, Breadcrumb, Popover } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import HandleHr from './HandleHr';

export class CreateHr extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.token,
            hrs: [0],
            id: 0,
            hrSaved: false,
        };

        this.addHr = this.addHr.bind(this);
        this.callbackHrSaved = this.callbackHrSaved.bind(this);
    }

    addHr() {
        window.location.reload()
    }

    callbackHrSaved = (childData) => {
        this.setState({ hrSaved: childData })
    }

    goBack() {
        return window.open("/hr/index", '_self');
    }

    render() {

        let addNewHr = this.state.hrSaved ? <Button style={{ position: 'relative', top: '15px' }} onClick={this.addHr}>Add new Hr</Button> : <Popover content="You need to save the prior Hr in order to add a new one"><Button disabled style={{ position: 'relative', top: '15px' }} onClick={this.addHr}>Add new Hr</Button></Popover>

        return (
            <Container fluid={true}>
                <Row>
                    <Col sm="12" style={{ display: 'inline-flex' }}>
                        <Button className="backButt" icon="caret-left" onClick={this.goBack}></Button>
                        <Breadcrumb className="bread">                            
                            <Breadcrumb.Item>Create HR</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>

                    <Row style={{ width: '100%' }}>
                        <Col style={{ minHeight: '50vh' }} sm='12'>
                            <div className="wizardFields wizardContacts" style={{ minHeight: '50vh' }}>
                                <div className="wizardBackground" style={{ height: 'inherit', textAlign: 'center' }}>
                                    <div>
                                        {this.state.hrs.map(i =>
                                            <HandleHr parentCallbackHrSaved={this.callbackHrSaved} token={this.state.user} key={i} />
                                            )}
                                    </div>
                                    {addNewHr}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Row>
            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Hr/CreateHr.js